import React from 'react';
import PropTypes from 'prop-types';
import { generateUUID } from '../../lib/UUID';

export default class ModalDropdown extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    value: PropTypes.number,
    options: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.object
      ]).isRequired,
    onCancel: PropTypes.func,
    onChange: PropTypes.func,
    parentDimensions: PropTypes.object
  };

  constructor(props) {
    super(props);

    this.buildOptionList = this.buildOptionList.bind(this);

    this.uniqueId = generateUUID();

    this.state = {
      dimensions: props.parentDimensions
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ dimensions: nextProps.parentDimensions });
  }

  buildOptionList() {
    const listItemGenerator = (key, value) =>
      <li
        key={`modal-dropdown-item-${this.uniqueId}-${key}`}
        onClick={() => this.props.onChange(key)}
        className={(''+key) === (''+this.props.value) ? 'active' : ''}
      >
        {value}
      </li>;

    if (Array.isArray(this.props.options)) {
      return this.props.options.map(value => listItemGenerator(value, value));
    } else if (typeof(this.props.options) === 'object') {
      return Object.keys(this.props.options).map(keyValue => listItemGenerator(keyValue, this.props.options[keyValue]));
    } else {
      console.error('invalid options passed to ModalDropdown component');
      return null;
    }
  }

  render() {
    let classNames = [ 'modal' ];
    if (this.props.className) classNames.push(this.props.className);
    classNames.push('modal-dropdown');
    classNames.push('modal-' + this.uniqueId);

    let style = {};
    if (this.state.dimensions) {
      style = {
        top: this.state.dimensions.top,
        left: this.state.dimensions.left,
        right: this.state.dimensions.right,
        width: this.state.dimensions.width
      };
    }

    return (
      <div key={this.uniqueId} className={classNames.join(' ')}>
        <div className="modal--backdrop" onClick={this.props.onCancel}/>
        <div className="modal--container" style={style}>
          <ul>{this.buildOptionList()}</ul>
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/ProductModal/modal_dropdown.js
 **/